import { useState, FC, useEffect } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { authSelector } from '@/store/selectors';
interface props {
  search: any;
}
const DropDownAppBar: FC<props> = ({ search }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItem, setSelectedItem] = useState<string>('My Memvys');
  const [profileAnchorEl, setProfileAnchorEl] = useState<null | HTMLElement>(null);
  const { user } = useSelector(authSelector);
  const router = useRouter();
  const open = Boolean(anchorEl);
  const openProfileMenu = Boolean(profileAnchorEl);

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setProfileAnchorEl(null);
  };

  const handleProfileMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileAnchorEl(null);
  };

  const handleMenuItemClick = (item: string) => {


    if (item === 'drafts') {
      router.push(`/app/home?p=drafts`);
    } else if (item === 'published') {
      router.push(`/app/home?p=published`);
    } else if (item === 'home') {
      router.push(`/app/home`);
    } else {
      router.push(`/app/${item.toLowerCase().replace(' ', '-')}`);
    }
    setSelectedItem(item);
    setAnchorEl(null);
  };
  useEffect(() => {
    if (router?.query?.p == undefined && router.pathname == '/app/home') {
      setSelectedItem('My Memvys');
    }

    if (router?.query.p === 'drafts') {
      setSelectedItem('Drafts');
    }

    if (router?.query?.p == 'published') {
      setSelectedItem('Published');
    }
    if (router.pathname == '/app/collaborators') {
      setSelectedItem('Collaborators');
    }
    if (router.pathname == '/app/profile') {
      setSelectedItem('Profile');
    }
  }, [router.pathname, router?.query]);
  const buttonBackground = router.pathname === '/app/story/[id]' ? 'white' : 'black';
  const iconSrc = router.pathname === '/app/story/[id]' ? '/icons/down-arrow-dark.svg' : '/icons/down-arrow-light.svg';

  return (
    <div>
      {/* Logo and selected item text */}
      <Box onClick={handleClickMenu} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        {selectedItem && !search && (
          <>
            <Box sx={{ mx: 2 }}>
              <Typography color='black' fontSize={'1.5rem'}>
                {search ? 'Results' : selectedItem}
              </Typography>
            </Box>{' '}
            {/* Show selected item next to logo */}
            <Image priority
              src='/icons/down-arrow-blue.svg'
              alt='logo'
              style={{ marginTop: '4px' }}
              width={16}
              height={16}
              quality={80}
            />
          </>
        )}
      </Box>
      {search && (
        <Box sx={{ marginLeft: 2 }}>
          <Typography color='black' fontSize={'1.5rem'}>
            {'Results'}
          </Typography>
        </Box>
      )}
      {/* Main menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: '#D8E8F6',
            borderRadius: '12px',
            padding: '8px',
            marginLeft: '14px',
          },
        }}>
        {[
          { label: 'My Memvys', key:'home', text:'My Memvys', icon: '/images/my-memvys-icon.svg', largeFont: true },
          { label: '○ Drafts',key:'drafts', text:'Drafts', icon: '/images/drafts-icon.svg', largeFont: false },
          { label: '○ Published',key:'published', text:'Published', icon: '/images/published-icon.svg', largeFont: false },
          { label: 'Collaborators', key:'collaborators', text:'Collaborators', icon: '/images/collab-icon.svg', largeFont: true },
        ].map((item, index) => (
          <div key={item.label}>
            <MenuItem
              onClick={() => {
                handleMenuItemClick(item.key);
                setSelectedItem(item.text);
              }}
              sx={{
                justifyContent: 'space-between',
                width: '180px',

                fontSize: item.largeFont ? '16px' : '14px',
                backgroundColor: selectedItem === item.text ? '#0072CE' : 'transparent',
                color: selectedItem === item.text ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: '#0072CE',
                  color: '#fff',
                  '& .menu-icon': {
                    filter: 'brightness(0) invert(1)',
                  },
                },
              }}>
              {item.label}
              {item?.text !== 'Profile' && (
                <Image priority
                  className='menu-icon'
                  src={item.icon}
                  alt='logo'
                  width={13.33}
                  height={13.33}
                  quality={80}
                  style={{
                    filter: selectedItem === item.text ? 'brightness(0) invert(1)' : '',
                  }}
                />
              )}
            </MenuItem>

            {index < 4 && <hr style={{ height: '0.1px', backgroundColor: '#C6D7E7', border: 'none', margin: '0' }} />}
          </div>
        ))}
      </Menu>
    </div>
  );
};

export default DropDownAppBar;
